module.exports = __webpack_public_path__ + "media/images/result_sets/circles/4r3r1n2r-b6a945185fddd9c97d04aa5fffe54cb0.svg";